/* Pépé Dive — variant picker: auto-correct impossible combinations
   When a customer picks a value (e.g. Maat "44 W") and the other option is still on a value
   that doesn't exist with it (e.g. Pasvorm "Standaard"), switch that other option to the
   first value that is available. Only one automatic step per customer click. */
(function () {
  if (window.__ppVariantAutoSelect) return;
  window.__ppVariantAutoSelect = true;

  var GROUP = '.product-form__input';

  document.addEventListener(
    'change',
    function (event) {
      if (!event.isTrusted) return; // ignore our own automatic clicks
      var target = event.target;
      if (!target || !target.closest) return;
      var oldPicker = target.closest('variant-selects');
      if (!oldPicker) return;
      var scope = oldPicker.closest('product-info') || document;
      var groups = Array.prototype.slice.call(oldPicker.querySelectorAll(GROUP));
      var changedIndex = groups.indexOf(target.closest(GROUP));
      waitForNewPicker(scope, oldPicker, changedIndex);
    },
    true
  );

  // The theme inserts the new <variant-selects> right before the old one and then hides/removes the old one
  function waitForNewPicker(scope, oldPicker, changedIndex) {
    var started = Date.now();
    (function check() {
      var replaced = !oldPicker.isConnected || oldPicker.style.display === 'none';
      if (replaced) {
        var candidate = oldPicker.isConnected ? oldPicker.previousElementSibling : null;
        if (!candidate || candidate.tagName !== 'VARIANT-SELECTS') {
          candidate = null;
          var all = scope.querySelectorAll('variant-selects');
          for (var i = 0; i < all.length; i++) {
            if (all[i] !== oldPicker && all[i].id === oldPicker.id) { candidate = all[i]; break; }
          }
        }
        if (candidate && candidate !== oldPicker) fixCombination(candidate, changedIndex);
        return;
      }
      if (Date.now() - started < 4000) setTimeout(check, 60);
    })();
  }

  function fixCombination(picker, changedIndex) {
    var groups = picker.querySelectorAll(GROUP);
    for (var i = 0; i < groups.length; i++) {
      if (i === changedIndex) continue;
      var checked = groups[i].querySelector('input[type="radio"]:checked');
      if (!checked || !checked.classList.contains('disabled')) continue;
      var alternative = groups[i].querySelector('input[type="radio"]:not(.disabled)');
      if (!alternative) continue;
      alternative.checked = true;
      alternative.dispatchEvent(new Event('change', { bubbles: true }));
      return; // one automatic step; the next render shows the corrected combination
    }
  }
})();
